import { useState } from "react";
import { Play } from "lucide-react";

export const VIDEO_ID = "1tLxnoVRO3JKnqSYjK4HAnHyHQgDwwfOm";
const EMBED_URL = `https://drive.google.com/file/d/${VIDEO_ID}/preview`;

const VideoPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoUrl = isPlaying ? `${EMBED_URL}?autoplay=1` : EMBED_URL;

  return (
    <div className="w-full" data-testid="hero-video-player">
      <div className="mb-3">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.24em] text-slate-500">
          Inside 50 CR Club
        </p>
      </div>
      <div className="relative aspect-video overflow-hidden rounded-lg border border-white/90 bg-[#101114] ring-1 ring-violet-300/70 shadow-[0_0_56px_rgba(167,139,250,0.72),0_20px_60px_rgba(15,23,42,0.2)]">
      <iframe
        src={videoUrl}
        title="50 CR Club introduction video"
        className="h-full w-full"
        allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen
      />
        {!isPlaying && (
          <button
            type="button"
            onClick={() => setIsPlaying(true)}
            aria-label="Play 50 CR Club introduction video"
            className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-violet-600/95 text-white shadow-[0_0_32px_rgba(167,139,250,0.8)] transition-transform hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white sm:h-20 sm:w-20"
          >
            <Play className="ml-1 h-7 w-7 fill-current sm:h-8 sm:w-8" />
          </button>
        )}
      </div>
    </div>
  );
};

export default VideoPlayer;